import { render, staticRenderFns } from "./SimpleModeSetting.vue?vue&type=template&id=5b27cabc"
import script from "./SimpleModeSetting.vue?vue&type=script&lang=js"
export * from "./SimpleModeSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\cxy\\project\\zcy\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b27cabc')) {
      api.createRecord('5b27cabc', component.options)
    } else {
      api.reload('5b27cabc', component.options)
    }
    module.hot.accept("./SimpleModeSetting.vue?vue&type=template&id=5b27cabc", function () {
      api.rerender('5b27cabc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/sysParam/SimpleModeSetting.vue"
export default component.exports